<template>
<!-- <v-container> -->
<v-layout row wrap fill-height
>
    <v-flex xs12 >
       <v-list>
          <v-list-tile
            v-for="(item, id) in question"
            :key="item.id"
            avatar
            @click=""
          >
          <v-flex xs7>
            <v-list-tile-content>
              <!-- <span><v-list-tile-title v-text="item.id"></v-list-tile-title> -->
              <!-- <span>{{item.id}}. some textasssssssssssssssssssssssssssssssssssssdddddd 233333333333 2sdasdas - oasdasd asasdasdasdasdadaadadadasd ooasdasd</span> -->

              <!-- <v-list-tile-title v-text="item.id"></v-list-tile-title> -->
              <span class="text-xs-left">{{item.question}}</span>
            </v-list-tile-content>
          </v-flex>
          <v-flex xs5 >
            <v-list-tile-content class="v-radio-button-end">
              <v-radio-group
              class="text-md-right"
              row
              v-model="answer[item.id]"
              >
                <v-radio
                    v-for="n in parseInt(item.scale)"
                    :key="n"
                    :label="` ${n}`"
                    :value="n"
                    color='pink'
                ></v-radio>
              </v-radio-group>
            </v-list-tile-content>
          </v-flex>
          </v-list-tile>
        </v-list>
        {{answer}}
    </v-flex>
    </v-layout>
    <!-- </v-container> -->
</template>

<script>
export default {
  name: 'kompetencje',
  data: () => ({
    question: '',
    answer: {}
  }),
  created: function () {
    const url = 'http://coachingspace.pl/php/test2.php'
    this.$http
      .get(url, { mode: 'no-cors' })
      .then(response => {
        console.log('RR', response.data)
        this.question = response.data
      })
      .catch(error => {
        console.log('EEEE', error)
      })
  }
}
</script>

<style scoped>
.v-radio-button-end {
    align-items: flex-end;
}
</style>
